module.exports = ['Male', 'Female', 'Non-Binary', 'Prefer not to say'];
